/**
 * 画像・動画関連の操作を行うUtilクラス。
 */
export default class MediaUtil {
	/**
	 * ReviCoにて受付可能な画像・動画拡張子一覧
	 */
	public static validExtensions = [".gif", ".jpg", ".jpeg", ".png", ".mov", ".mp4"];

	/**
	 * ReviCoにて投稿可能な画像種別一覧。
	 */
	public static validImageType: string[] = ["image/jpeg", "image/gif", "image/png"];
	/**
	 * 対象ファイルがReviCoにて投稿可能な画像拡張子であるかチェックする。
	 * @param file 対象ファイル
	 * @returns TRUE:投稿可能 / FALSE:投稿不可能
	 */
	public static isValidExtensionImageFile(file: File): boolean {
		let result = false;
		this.validImageType.map((e) => {
			if (file.type.match(e)) {
				result = true;
			}
		});
		return result;
	}

	/**
	 * ReviCoにて投稿可能な動画種別一覧。
	 */
	public static validMovieType: string[] = ["video/mp4", "video/quicktime"];
	/**
	 * 対象ファイルがReviCoにて投稿可能な画像拡張子であるかチェックする。
	 * @param file 対象ファイル
	 * @returns TRUE:投稿可能 / FALSE:投稿不可能
	 */
	public static isValidExtensionMovieFile(file: File): boolean {
		let result = false;
		this.validMovieType.map((e) => {
			if (file.type === e) {
				result = true;
			}
		});
		return result;
	}

	/**
	 * ReviCoにて投稿可能な画像・動画ファイルサイズ上限。
	 * 単位はバイト。
	 */
	public static maxFileSize = {
		/**
		 * 画像投稿。
		 */
		image: 1024 * 1024 * 10, // = 10MB
		/**
		 * 動画投稿。
		 */
		movie: 1024 * 1024 * 500, // = 500MB
	};
	/**
	 * 対象ファイルがReviCoにて投稿可能なファイルサイズであるかチェックする。
	 * @param file 対象ファイル
	 * @param type 種別
	 * @returns TRUE:投稿可能 / FALSE:投稿不可能
	 */
	public static isValidFileSize(file: File, type: "profilePicture" | "image" | "movie"): boolean {
		const fileSize = file.size;
		switch (type) {
			case "profilePicture":
			case "image":
				if (fileSize > this.maxFileSize.image) {
					return false;
				}
				return true;
			case "movie":
				if (fileSize > this.maxFileSize.movie) {
					return false;
				}
				return true;
			default:
				throw new Error(`想定外のtypeが渡されました。type: ${type}`);
		}
	}

	/**
	 * ReviCoにて投稿可能な動画再生時間。
	 * 単位は秒。
	 */
	public static maxMoviePlayTime = 30;
	/**
	 * 対象ファイルがReviCoにて投稿可能な動画再生時間以内の動画であるかチェックする。
	 * @param file 対象ファイル
	 * @returns TRUE:投稿可能 / FALSE:投稿不可能
	 */
	public static isValidMoviePlayTimeLength = (file: File): Promise<{ isValid: boolean; playTime: number }> => {
		const maxMoviePlayTime = this.maxMoviePlayTime;
		return new Promise((resolve: (arg0: { isValid: boolean; playTime: number }) => void) => {
			// 一度動画DOMを生成し、再生時間を取得する
			const tmpVideoElement = document.createElement("video");
			const fileURL = URL.createObjectURL(file);
			tmpVideoElement.src = fileURL;
			tmpVideoElement.ondurationchange = function () {
				URL.revokeObjectURL(tmpVideoElement.src);
				const playTime = tmpVideoElement.duration;
				if (playTime > maxMoviePlayTime) {
					resolve({ isValid: false, playTime });
				}
				resolve({ isValid: true, playTime });
			};
		});
	};
}
